import UUID from "./uuid";

const PROJECT_MESSAGES_KEY = 'projectMessages'
const PROJECT_IMAGES_KEY = 'projectImages'
const guestKey = 'guest'

function getUser() {
    const user = localStorage.getItem('user') || '{}'
    return JSON.parse(user)
}

function setUser(user) {
    localStorage.setItem('user', JSON.stringify(user))
}

function getProjects() {
    const projects = localStorage.getItem('projects') || '[]'
    return JSON.parse(projects)
}

function getProjectMessages(projectType) {
    const projects = JSON.parse(localStorage.getItem(PROJECT_MESSAGES_KEY) || '[]')
    return projects.filter(p => {
        return p.projectType === projectType
    })
}

function getAllProjectMessages() {
    const messages = JSON.parse(localStorage.getItem(PROJECT_MESSAGES_KEY) || '[]')
    return messages
}

function setAllProjects(projects) {
    const projectsStorage = getProjects()
    let newProjects;

    if (projectsStorage.length) {
        //Add new projects to storage
        projects.forEach(p => {
            const projectFind = projectsStorage.findIndex(project => project.projectId === p.projectId);

            if (projectFind === -1) {
               projectsStorage.push(p)
            }else{
                if(projectsStorage[projectFind].lastStep !== p.lastStep && projectsStorage[projectFind].sync === p.sync){
                    projectsStorage[projectFind] = p
                }
            }
        })
        //Remove from storage deleted projects
        const storage_length = projectsStorage.length - 1
        for (var i = storage_length; i >= 0; --i) {
            const projectFind = projects.findIndex(project => project.projectId === projectsStorage[i].projectId);

            if (projectFind === -1 && projectsStorage[i].sync) {
                projectsStorage.splice(i, 1)
            }
        }

        newProjects = projectsStorage
    } else {
        newProjects = projects
    }

    setProjects(newProjects);
}

function setProjects(projects) {
    localStorage.setItem("projects", JSON.stringify(projects))
}

function setProjectMessages(projectMessages) {
    localStorage.setItem(PROJECT_MESSAGES_KEY, JSON.stringify(projectMessages))
}

function getProject(projectIndex) {
    const projects = getProjects()
    return projects[projectIndex]
}

function createProject(type, name, problem, customer) {
    const user = getUser()
    const today= new Date();
    const project = {
        "type": type,
        "userId": user.id,
        "projectId": UUID.generate(),
        "name": name,
        "problem": problem,
        "customer": customer,
        "sync": false,
        "lastStep": 0,
        "forms": "{}",
        "lastUpdated": today
    }
    const projects = getProjects()
    projects.push(project)

    //setProjects(projects)

    return {
        index: projects.length - 1,
        project: project
    }
}

function updateProject(index, type, name, problem, customer, isOffline) {
    const projects = getProjects()
    const user = getUser()
    const project = projects[index]
    const today= new Date();

    project['type'] = type
    project['userId'] = user.id
    project['name'] = name
    project['problem'] = problem
    project['customer'] = customer
    project['sync'] = !isOffline
    project['lastUpdated'] = today
    //setProjects(projects)
    return project
}

function deleteProject(index) {
    const projects = getProjects()
    projects.splice(index, 1);
    setProjects(projects)
}

function replaceProject(index, project) {
    const projects = getProjects()
    projects[index] = project
    setProjects(projects)
}

function getProjectForms(projectIndex) {
    return JSON.parse(getProject(projectIndex)['forms'])
}

function getProjectId(projectIndex) {
    return getProject(projectIndex).projectId
}

function updateProjectForm(projectIndex, stepName, stepNumber, form = {}, isOffline = false) {
    const user = getUser()
    const projects = getProjects()
    const project = projects[projectIndex]
    const projectForms = getProjectForms(projectIndex)

    projectForms[stepName] = Object.keys(form).length ? form : {}
    project.forms = JSON.stringify(projectForms)

    if (stepNumber>project.lastStep) project.lastStep = stepNumber
    project.userId = user.id
    project.sync = !isOffline

    const today= new Date();
    project.lastUpdated = today
    setProjects(projects)
    return project
}

function setGuest(guest) {
    localStorage.setItem(guestKey, JSON.stringify(guest))
}

function getGuest() {
    return JSON.parse(localStorage.getItem(guestKey)) || '{}'
}

function removeGuest() {
    localStorage.removeItem(guestKey)
}

function getProjectImages() {
    const images = localStorage.getItem(PROJECT_IMAGES_KEY) || '[]'
    return JSON.parse(images)
}

function setProjectImages(projectImages) {
    localStorage.setItem(PROJECT_IMAGES_KEY, JSON.stringify(projectImages))
}

function getProjectImage(projectId, keyStep) {
    const images = getProjectImages()
    const index = images.findIndex(i => i.projectId === projectId && i.step === keyStep)
    let image = false
    if (index>-1) image = images[index]
    return { index, image }
}

function getImagesByProjectId(projectId) {
    const images = getProjectImages()
    const result = images.filter(img => img.projectId === projectId);
    return result
}

function saveProjectImage(projectId, keyStep, imageData) {
    const {_, image} = getProjectImage(projectId, keyStep)
    if (image) {
        updateProjectImage(projectId, keyStep, imageData)
    } else {
        createProjectImage(projectId, keyStep, imageData)
    }
}

function createProjectImage(projectId, keyStep, imageData) {
    const image = {
        "imageId": UUID.generate(),
        "projectId": projectId,
        "step": keyStep,
        "image": imageData
    }
    let images = getProjectImages()
    images.push(image)
    setProjectImages(images)
}

function updateProjectImage(projectId, keyStep, imageData) {
    let images = getProjectImages()
    const {index, _} = getProjectImage(projectId, keyStep)
    const image = images[index]
    image['image'] = imageData
    setProjectImages(images)
}

function clearAll() {
    localStorage.removeItem('user')
    localStorage.removeItem('projects')
    localStorage.removeItem(PROJECT_IMAGES_KEY)    
    localStorage.removeItem('current_project')
    localStorage.removeItem('vue-authenticate.')
    localStorage.removeItem('vue-authenticate._blank_state')
}

export default {
    getUser,
    setUser,
    getProjects,
    setProjects,
    setAllProjects,
    getProjectId,
    getProjectForms,
    updateProjectForm,
    getProject,
    createProject,
    updateProject,
    deleteProject,
    replaceProject,
    clearAll,
    setProjectMessages,
    getProjectMessages,
    getAllProjectMessages,
    setGuest,
    getGuest,
    removeGuest,
    getProjectImages,
    setProjectImages,
    getProjectImage,
    getImagesByProjectId,
    saveProjectImage,
    createProjectImage,
    updateProjectImage
}
